import { useUnassignRestaurantSupplierApi } from 'apis/restaurant-suppliers';
import {
  BoxProps,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from 'design-system';
import React from 'react';

export interface IUnassignRestaurantModalCell extends BoxProps {
  relationId: number;
  restaurantName: string;
  trigger: JSX.Element;
}

export const UnassignRestaurantModalCell = ({ relationId, restaurantName, trigger }: IUnassignRestaurantModalCell) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: unassignRestaurant, isLoading } = useUnassignRestaurantSupplierApi();

  const handleUnassign = () => {
    unassignRestaurant({ relationId }, { onSuccess: () => onClose() });
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: onOpen })}

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Unassign restaurant</ModalHeader>
          <ModalBody>
            <Text>Are you sure you want to unassign {restaurantName || 'this restaurant'} from this supplier?</Text>
          </ModalBody>
          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='gray' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='solid' colorScheme='red' onClick={handleUnassign} isLoading={isLoading}>
                Unassign
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
